import xw from 'xwind';
import styled from '@emotion/styled';

const ErrorMessage = styled.div(xw`text-xs sm:text-base text-negative`);

export default ErrorMessage;
